import { styled } from '@mui/material/styles';

export const CalendarContainer = styled('div')(() => ({
  display: 'inline-block',
  overflow: 'hidden',
  width: '100%',

  '& .MuiDateCalendar-root > div[style*="margin: 12px"]': {
    margin: '0 !important'
  },
  
  // Target calendar header container (remove margin: 12px)
  '& .MuiDateCalendar-root > div[style*="justify-content: space-between"]': {
    margin: 0
  },
  // Force calendar root to take full width instead of 320px
  '& .MuiDateCalendar-root': {
    width: '100% !important',
    maxHeight: '334px',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
  },
  // Override weekday header layout
  '& .MuiDayCalendar-header': {
    justifyContent: 'space-around !important'
  },
  // Override weekday <span> styles
  '& .MuiDayCalendar-weekDayLabel': {
    height: '32px !important'
  }
}));
